<script setup lang="ts">
import { useSiteStore } from '~/stores/site.store';

const siteStore = useSiteStore();
const locale = useLocaleStore();
const runtimeConfig = useRuntimeConfig();

const { $t } = useNuxtApp();

const route = useRoute();
const page = useGetPage({ setSeoMeta: false });

const isContent = computed(() => {
  return (
    (!!page.value && page.value?.MobileApp?.component === 'WebViewComponent') ||
    page.value?.MobileApp?.component === 'ContactUsComponent' ||
    page.value?.MobileApp?.component === 'PromotionComponent' ||
    page.value?.MobileApp?.component === 'PromopagesComponent' ||
    page.value?.MobileApp?.component === ''
  );
});

const isGame = computed(() => !!route.params.game);

const displayBanner = computed(() => {
  const isContentPage = isContent.value;
  const isGamePage = isGame.value;
  const isHomeProviders = route.fullPath.startsWith('/home/providers');
  return (
    !isContentPage && !isGamePage && !!page.value?.Mapping && !isHomeProviders
  );
});

const isCertification = computed(
  () => route.params?.contentType === 'certification',
);

const displayPanel = computed(() => {
  const appsetting = siteStore.getFeatureFlags.get(
    'website.enablecategorypanel',
  );
  const isGamePage = isGame.value;
  return appsetting && !isGamePage;
});

const panelContent = computed(() => {
  const contentKey = `vertical.${route.params.contentType.replace('-', '')}.panelcontent`;
  const contentValue = locale.localeKey(contentKey);
  return contentKey !== contentValue ? contentValue : null;
});

const displayCategoryNavigation = computed(() => {
  const isContentPage = isContent.value;
  const isGamePage = isGame.value;
  const isHomeProviders = route.fullPath.includes('/providers');
  return !isContentPage && !isGamePage && !isHomeProviders;
});

const desktopAspectRatio = computed(() =>
  page.value.Mapping.toLowerCase() !== 'home' ? '16/3' : '16/5',
);
const mobileAspectRatio = computed(() =>
  page.value.Mapping.toLowerCase() !== 'home' ? '355/104' : '344/247',
);
</script>
<template>
  <div>
    <MarketingBanner
      v-if="
        displayBanner && String(runtimeConfig.public.newBannerWidget) !== 'true'
      "
      displayPlaceholder
      :vertical="page?.Mapping"
      :desktop-aspect-ratio="desktopAspectRatio"
      :mobile-aspect-ratio="mobileAspectRatio"
    />
    <MarketingBannerV2
      v-else-if="
        displayBanner && String(runtimeConfig.public.newBannerWidget) === 'true'
      "
      :vertical="page?.Mapping"
      :desktop-aspect-ratio="desktopAspectRatio"
      :mobile-aspect-ratio="mobileAspectRatio"
    />
    <LazyDesignSystemInformationPanel
      v-if="displayPanel && !!panelContent"
      :text-title="`${$t('vertical.category.tooltip.title')} ${$t(
        `vertical.${route.params.contentType.replace('-', '')}.paneltitle`,
      )}?`"
      class="category-panel"
      :content="panelContent"
      icon="question"
      toggleable
      :toggle-persist="page?.Alias"
    />
    <LazyUserInterfaceCategoryNavigation
      v-if="displayCategoryNavigation || (isCertification && !isGame)"
    />
    <NuxtPage :page-key="String(route.params.contentType)" :keepalive="true" />

    <ContentSeo v-if="!isContent" />
  </div>
</template>
